import PlannerControllerBase from './planner/controllers/base';
import ResponseController    from './planner/controllers/response_controller';
import CellsController       from './planner/controllers/cells_controller';
import BlackOverController   from './planner/controllers/black_over_controller';
import ScheduleController    from './planner/controllers/schedule_controller';
import DialogsController     from './planner/controllers/dialogs_controller';
import KeyboardController    from './planner/controllers/keyboard_controller';
import CommandsController    from './planner/controllers/commands_controller';
import LinesController       from './planner/controllers/lines_controller';
import ScrollController      from './planner/controllers/scroll_controller';
import GlobalController      from './planner/controllers/global_controller';
import TasksController       from './planner/controllers/tasks_controller';
import PropsController       from './planner/controllers/props_controller';
import SearchController       from './planner/controllers/search_controller';

export class PlannerController extends PlannerControllerBase {
  responseController:  ResponseController;
  cellsController:     CellsController;
  blackOverController: BlackOverController;
  scheduleController:  ScheduleController;
  dialogsController:   DialogsController;
  keyboardController:  KeyboardController;
  commandsController:  CommandsController;
  linesController:     LinesController;
  scrollController:    ScrollController;
  globalController:    GlobalController;
  tasksController:     TasksController;
  propsController:     PropsController;
  searchController:    SearchController;
  constructor(tag){
    super(tag);
    this.responseController  = new ResponseController(tag);
    this.cellsController     = new CellsController(tag);
    this.blackOverController = new BlackOverController(tag);
    this.scheduleController  = new ScheduleController(tag);
    this.dialogsController   = new DialogsController(tag);
    this.keyboardController  = new KeyboardController(tag);
    this.commandsController  = new CommandsController(tag);
    this.linesController     = new LinesController(tag);
    this.scrollController    = new ScrollController(tag);
    this.globalController    = new GlobalController(tag);
    this.tasksController     = new TasksController(tag);
    this.propsController     = new PropsController(tag);
    this.searchController    = new SearchController(tag);
  }
}
